import { ITravelTypeDetailDTO } from "api/swagger/ApiClient";
import { ValidationController } from "aurelia-validation";

export interface TravelTypeModel {
  data: ITravelTypeDetailDTO;
  hasChanged: boolean;
  cancelChanges(): void;
  rebindData(dto: ITravelTypeDetailDTO): void;
  validationController: ValidationController;
}
